import { useQuery } from '@tanstack/react-query';
import { getRevenueKpi, serializeLabelIds } from '../services/api/reports';

/**
 * Monthly invoiced-revenue KPI (P1 Finance) for ONE calendar year, split by
 * project label, against the annual target spread as a catch-up pace.
 *
 * A calendar year rather than a rolling window: the target resets each
 * January, so a window straddling two years would draw two unrelated catch-up
 * curves in one chart.
 *
 * Query key includes the year, the label selection and the forecast window so
 * no selector poisons the cache. `labelIds` empty/omitted = all labels;
 * `null` inside the array selects the No-label bucket.
 *
 * `forecastWindow` (MKS-210) is the number of complete months the retainer
 * forecast averages. Omitted = the backend's 3-month default.
 */
export function useRevenueKpi(
  year: number,
  labelIds: (number | null)[] = [],
  forecastWindow?: number
) {
  return useQuery({
    // Serialize the selection: a fresh array literal each render would
    // otherwise produce a new key identity on every render.
    queryKey: ['revenueKpi', year, serializeLabelIds(labelIds), forecastWindow ?? 'default'],
    queryFn: () => getRevenueKpi(year, labelIds, forecastWindow),
  });
}
